import { combineReducers } from 'redux';
import trackTask from './trackTask';

export default combineReducers({ trackTask });
